<template>
  <div>
    <generic-upload
      name="Upload Image"
      class="img-upload"
      ref="fileUpload"
      @on-success="onSuccess"
    />
  </div>
</template>
<script>
import GenericUpload from '../components/override/GenericUpload'
export default {
  components: { GenericUpload },
  methods: {
    onSuccess (files) {
      for (let file of files) {
        console.log(file.file, file.key)
      }
    }
  }
}
</script>
